// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-global-policy-pre-content-rule-missing-trademark',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    template: `
        <div class="mt-4 mx-4" ngModelGroup="ruleMissingTrademark">
            <div class="row">
                <div class="col-24 col-md-30">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h4 class="font-weight-300" translate>Policy setup</h4>
                        </div>
                        <div class="card-body">
                            <form>
                                <div class="form-group row" *ngFor="let row of ngModel; let i = index; trackBy: trackByIndex">
                                    <label [attr.for]="'policy-pre-content-inputfield-' + i"
                                           class="pr-0 col-8 col-form-label text-bold text-right capitalize-first-letter">
                                        <span translate>Brand name</span>
                                        <span>*</span>
                                    </label>
                                    <div class="col-sm-40 col-lg-18 pr-lg-0">
                                        <input [(ngModel)]="row.content"
                                               name="brandName_{{i}}"
                                               type="text"
                                               class="form-control"
                                               [attr.id]="'policy-pre-content-inputfield-' + i"
                                               placeholder="{{ 'insert brand name' | translate }}"
                                               (ngModelChange)="onModelChange()"
                                               required
                                        />
                                    </div>
                                    <div class="order-4 order-lg-3 col-sm-40 col-lg-16 pt-2 pt-lg-0 pr-lg-0">
                                        <angular-selector
                                                labelAttr="name"
                                                valueAttr="value"
                                                placeholder="{{'Please choose a trademark' | translate}}"
                                                [options]="tradeMarkOptions"
                                                [(ngModel)]="row.sub_entry"
                                                name="trademark_{{i}}"
                                                [removeButton]="false"
                                                (change)="onModelChange()"
                                                [required]="true">
                                        </angular-selector>
                                    </div>
                                    <div class="order-lg-4 order-3 col-8 col-lg-6 pt-2 pt-lg-0 pr-0 pr-lg-3 text-right">
                                        <button type="button"
                                                class="btn btn-border-radius btn-secondary"
                                                (click)="removeRow(row)">
                                            <span class="fas fa-trash-alt" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                </div>
                            </form>

                            <div class="row">
                                <div class="col-sm-40 offset-sm-8">
                                    <button type="button"
                                            class="btn btn-border-radius btn-secondary"
                                            (click)="addRow()">
                                        <span class="fas fa-plus" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-24 col-md-18">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h4 class="font-weight-300" translate>
                                Information
                            </h4>
                        </div>
                        <div class="card-body">
                            <p>
                                <strong translate>How to setup this policy</strong>
                            </p>
                            <p translate>To setup this policy, you need to tell us which brand name should end with TM or ™</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class FormGlobalPolicyPreContentRuleMissingTrademarkComponent implements OnInit {
    @Input() model: any;
    ngModel: any = [];
    tradeMarkOptions: any = [
        {
            name: 'BRAND(TM)',
            value: 'BRAND\\(TM\\)',
        },
        {
            name: 'BRAND (TM)',
            value: 'BRAND \\(TM\\)',
        },
        {
            name: 'BRAND™',
            value: 'BRAND™',
        },
        {
            name: 'BRAND ™',
            value: 'BRAND ™',
        },
    ];

    ngOnInit () {
        this.addRow();
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    onModelChange () {
        const rules: any = [];
        this.ngModel.forEach((row: any, index: number) => {
            rules.push({
                name: 'Missing trademark for: ' + row.content,
                case_sensitive: true,
                inverse: false,
                operator: 'conforms_with',
                query: row.content + '\\s*(?:\\(TM\\)|™)?',
                type: 'page_text',
                sub_entry: row.sub_entry.replace('BRAND', row.content),
            });
        });

        this.model = rules;
    }

    addRow () {
        this.ngModel.push({ content: '', sub_entry: 'BRAND\\(TM\\)' });
    }

    removeRow (row: any) {
        const index = this.ngModel.indexOf(row);
        if (index !== -1) {
            this.ngModel.splice(index, 1);
        }
    }
}
